import { render, staticRenderFns } from "./updatepwd.vue?vue&type=template&id=cebc813a&scoped=true&"
import script from "./updatepwd.vue?vue&type=script&lang=js&"
export * from "./updatepwd.vue?vue&type=script&lang=js&"
import style0 from "./updatepwd.vue?vue&type=style&index=0&id=cebc813a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebc813a",
  null
  
)

export default component.exports